import { Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { TenantRouterService } from '../../../shared/services/tenant-router.service';
import { UserProfileService } from '../../../shared/services/user-profile.service';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    imports: [MatButtonModule, MatMenuModule, MatIconModule, MatDividerModule, MatTooltipModule, RouterLink],
})
export class UserComponent {
    private readonly userProfileService = inject(UserProfileService);
    private readonly tenantRouterService = inject(TenantRouterService);

    public readonly isExtension = input<boolean>(false);

    protected readonly user = toSignal(this.userProfileService.getOwnUserProfile());

    protected signOut(): void {
        this.tenantRouterService.navigate(['sign-out']);
    }
}
